import type { RouterOutputs } from "@/types/rpc";
import { deferredResourceQueryOptions } from "@/utils/deferred-resource-query";
import { orpc } from "@/utils/orpc.client";

export type WikipediaResource = RouterOutputs["music"]["getWikipediaResource"];

interface WikipediaResourceQueryOptionsInput {
  wikidataId: string;
  locale: string;
  enabled?: boolean;
}

export function getWikipediaResourceQueryOptions({
  wikidataId,
  locale,
  enabled,
}: WikipediaResourceQueryOptionsInput) {
  return deferredResourceQueryOptions(
    orpc.music.getWikipediaResource.queryOptions({
      input: { wikidataId, locale },
      enabled,
    }),
  );
}
